import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import "./diagram-node.css";

export const DiagramNode = memo(function DiagramNode({ data }) {
  const Icon = data?.icon;

  return (
    <div
      className="diagram-node diagram-node--clickable"
      onMouseEnter={() => data?.onHover?.(data?.nodeId)}
      onMouseLeave={() => data?.onHover?.(null)}
    >
      <Handle type="target" position={Position.Left} />

      {Icon && (
        <span className="diagram-node__icon">
          <Icon />
        </span>
      )}

      <div className="diagram-node__label">{data?.label}</div>

      <Handle type="source" position={Position.Right} />
    </div>
  );
});